import "./RemoveTodoList.scss";

function RemoveTodoList({
  cancelRemoveTodoList,
  removeTodoList,
  todoListTitle,
}) {
  return (
    <div className="remove-todolist-content">
      <div className="modal-title">
        <div>Remove Todo List</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete "{todoListTitle}"?</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTodoList}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeTodoList}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveTodoList;
